import { ServiceBase } from "@app/shared";
import { DatadogGraphsApiResponse } from "./types";

export default class DatadogDashboardService extends ServiceBase {
  public async getGraphsForClient(timeframe: string, category: number): Promise<DatadogGraphsApiResponse[]> {
    return await this.makeGet("datadogDashboard/getGraphsForClient", { category, timeframe });
  }
}